module.exports = __webpack_public_path__ + "static/media/search.db9ad595.svg";